// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "3.81.4/styles/" + (chunkId === 225 ? "videojs" : chunkId) + ".chunk.css?" + {"225":"61b1a5e5a3f72961981e","753":"353faa143a2edd9cbb97"}[chunkId] + "";
};